export class HttpUnauthorizedError {}

export class HttpNotFoundError {}

export class HttpServerErrorError {}

export class HttpBadRequestError {
	constructor(public name?: string) {}
}
